
namespace Matrix.Exceptions {

    @Serenity.Decorators.registerClass()
    export class ExceptionLinkDialog extends Serenity.EntityDialog<ExceptionLinkRow, any> {
        protected getFormKey() { return ExceptionLinkForm.formKey; }
        protected getIdProperty() { return ExceptionLinkRow.idProperty; }
        protected getLocalTextPrefix() { return ExceptionLinkRow.localTextPrefix; }
        protected getNameProperty() { return ExceptionLinkRow.nameProperty; }
        protected getService() { return ExceptionLinkService.baseUrl; }
        protected getDeletePermission() { return ExceptionLinkRow.deletePermission; }
        protected getInsertPermission() { return ExceptionLinkRow.insertPermission; }
        protected getUpdatePermission() { return ExceptionLinkRow.updatePermission; }

        protected form = new ExceptionLinkForm(this.idPrefix);

    }
}